import {Injectable} from '@angular/core';


// added
import {CustomGoogleMapsAPIWrapper} from './customApiWrapper';
import {CustomCalculator} from './customClusterOptions';
import {AgmMarker} from '@agm/core/';
import MarkerClusterer, {MarkerClustererOptions} from '@google/markerclustererplus';


@Injectable()
export class CustomClusterManager {
    public _clustererInstance: Promise<MarkerClusterer>;
    public _resolver: Function;

    public _markers: Map<AgmMarker, Promise<google.maps.Marker>> =
        new Map<AgmMarker, Promise<google.maps.Marker>>();

    constructor(protected _mapsWrapper: CustomGoogleMapsAPIWrapper) {
        this._clustererInstance = new Promise<MarkerClusterer>((resolver) => {
            this._resolver = resolver;
        });
    }

    // Modified - added Calculator parameter
    init(options: MarkerClustererOptions, calculator: CustomCalculator): void {
        this._mapsWrapper.getNativeMap().then(map => {
            const clusterer = new MarkerClusterer(map, [], options);
            this._resolver(clusterer);
        });
        this.setCustomCalculator(calculator);
    }


    // Added method
    setCustomCalculator(calculator: CustomCalculator) {
        this._clustererInstance
            .then((cluster) => {
                return cluster;
            })
            .then(
                (cluster) => cluster.setCalculator(
                    (markers) => calculator.calculateFunction(markers, calculator.options = null)
                )
            );
    }

    addMarker(markerElement: any): void {
        if (markerElement === undefined) {
            return;
        }

        const clusterPromise: Promise<MarkerClusterer> = this._clustererInstance;
        const markerPromise = this._mapsWrapper
            .createMarker(<any>{
                position: {
                    lat: markerElement.latitude,
                    lng: markerElement.longitude
                },
                label: markerElement.label,
                draggable: markerElement.draggable,
                icon: markerElement.iconUrl,
                opacity: markerElement.opacity,
                visible: markerElement.visible,
                zIndex: markerElement.zIndex,
                title: markerElement.title,
                clickable: markerElement.clickable,

                // Added property to convey project information
                projectData: markerElement.projectData,

            }, false);

        Promise
            .all([clusterPromise, markerPromise])
            .then(([cluster, marker]) => {
                return cluster.addMarker(marker);
            });
        this._markers.set(markerElement, markerPromise);

    }
}


